import Header from './components/Header';
import Hero from './components/Hero';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <ContactSection />
        <CardsSection />
        <FAQSection />
        <TopicsSection />
        <MediaSection />
        <CommentsSection />
        <IndexSection />
        <CarouselSection />
        <UpdatesSection />
        <RankingSection />
        <FeaturesSection />
        <AboutSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}